<template>
  <div class="c-fa-new-step3 header">
    Lokasi
    <div class="fa-new-step1-content">
      Masukkan lokasi agar kami dapat merekomendasikan agen yang terdekat dengan posisi Anda.
    </div>
    <div class="fa-new-step1-content mt-3">
      <div class="form-group">
        <div class="form-control" data-toggle="modal" data-target="#modalProv" style="cursor:pointer;  border-radius: 10px;" >
          <div class="row">
            <div class="col-sm-11 resize-11" style="max-width: 85%; text-align: left;font-weight: 500; padding-top: 10px; letter-spacing: 0.22px;">
              {{ chooseProvinceName }}
            </div>
            <div class="col-sm-1 resize-1" style="padding-top: 10px;" >
              <img alt="delete" src="../../../../../assets/images/svg/ic-caret-down.svg" style="text-align:right;right: 0; display:inline; color:#777777;">
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="form-control" data-toggle="modal" data-target="#modalCity" style="cursor:pointer;  border-radius: 10px;" @click="getResponseCity()">
          <div class="row">
            <div class="col-sm-11 resize-11" style="max-width: 85%; text-align: left;font-weight: 500; padding-top: 10px; letter-spacing: 0.22px;">
              {{ chooseCityName }}
            </div>
            <div class="col-sm-1 resize-1" style="padding-top: 10px;" >
              <img alt="delete" src="../../../../../assets/images/svg/ic-caret-down.svg" style="text-align:right;right: 0; display:inline; color:#777777;">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade " id="modalCity" tabindex="-1" role="dialog" aria-labelledby="modalCityLabel" aria-hidden="true">
      <div class="modal-dialog modal-bottom" role="document">
        <div class="modal-content" style="height: 75vh;">
          <div class="modal-header" style="border-bottom: transparent; ">
            <div class="col-sm-11" style="margin:auto;">
              <h5 class="modal-title">Pilih kota</h5>
            </div>
            <a data-dismiss="modal" aria-label="Close" @click="closeModalCity()">
              <img alt="delete" src="../../../../../assets/images/svg/times.svg">
            </a>
          </div>
          <div class="modal-body" style="text-align: left; padding-top:24px;">
            <div class="row" style="text-align:center;">
              <div class="form-group col-sm-12" >
                <input type="text" class="form-control retangle" style=" border-radius: 15px; margin:auto; width: 93%;" placeholder="Cari kota"  @keyup="searchCity($event)">
              </div>
            </div>
            <div
              v-if="cities.length > 0"
              class="ex2"
              style="overflow: scroll; height: 43vh; font-size: 14px;">
              <ul class="list-group">
                <template
                  v-for="(city, key) in cities"
                >
                  <template  v-if="city.attributes.kd_kab !=''">
                    <li
                      :key="key"
                      class="list-group-item"
                      :class="{
                        'active': chooseCityID == city.id
                      }"
                      style="border:transparent; cursor:pointer;"
                      @click="chooseCity(city.id, city.attributes.nama)"
                    >
                      <div class="row">
                        <div class="col-sm-11 resize-11">
                          {{ city.attributes.nama }}
                        </div>
                        <div class="col-sm-1 resize-1">
                          <img v-if="chooseCityID == city.id" src="../../../../../assets/images/svg/selected.svg" class="image-padding">
                        </div>
                      </div>
                    </li>
                  </template>
                </template>
                <li class="list-group-item" style="display:none;"></li>
              </ul>
            </div>
            <div 
              v-if="cities.length == 0"
              id= "over" class="ex2" 
              style="height: 450px; width: 100%; position:absolute;">
              <img alt="banner" src="../../../../../assets/images/svg/emptystate-kota.svg"  class="img-responsive">
              <div class="content-step-1" style="text-align:center">
                Oppss
              </div>
              <div class="fa-new-step1-content" style="text-align:center">
                Kota yang kamu cari tidak dapat ditemukan
              </div>
            </div>
            <button  class="buttom-modal button-continue" :disabled="chooseCityID == null" @click="closeModalCity()">
              PILIH
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade " id="modalProv" tabindex="-1" role="dialog" aria-labelledby="modalProvLabel" aria-hidden="true">
      <div class="modal-dialog modal-bottom" role="document">
        <div class="modal-content" style="height: 75vh;">
          <div class="modal-header" style="border-bottom: transparent; ">
            <div class="col-sm-11" style="margin:auto;">
              <h5 class="modal-title">Pilih Provinsi</h5>
            </div>
            <a data-dismiss="modal" aria-label="Close" @click="closeModalProv()">
              <img alt="delete" src="../../../../../assets/images/svg/times.svg">
            </a>
          </div>
          <div class="modal-body" style="text-align: left; padding-top:24px;">
            <div class="row" style="text-align:center;">
              <div class="form-group col-sm-12" >
                <input type="text" class="form-control retangle" style=" border-radius: 15px; margin:auto; width: 93%;" placeholder="Cari Provinsi"  @keyup="searchProvince($event)">
              </div>
            </div>
            <div
              v-if="provinces.length > 0"
              class="ex2"
              style="overflow: scroll; height: 43vh; font-size: 14px;">
              <ul class="list-group">
                <li
                  v-for="(prov, key) in provinces"
                  :key="key"
                  class="list-group-item"
                  :class="{
                    'active': chooseProvinceID == prov.id
                  }"
                  style="border:transparent; cursor:pointer;"
                  @click="chooseProvince(prov.id, prov.attributes.nama, prov.attributes.kd_prov)"
                >
                  <div class="row">
                    <div class="col-sm-11 resize-11">
                      {{ prov.attributes.nama }}
                    </div>
                    <div class="col-sm-1 resize-1">
                      <img v-if="chooseProvinceID == prov.id" src="../../../../../assets/images/svg/selected.svg" class="image-padding">
                    </div>
                  </div>
                </li>
                <li class="list-group-item" style="display:none;"></li>
              </ul>
            </div>
            <div 
              v-if="provinces.length == 0"
              id= "over" class="ex2" 
              style="height: 450px; width: 100%; position:absolute;">
              <img alt="banner" src="../../../../../assets/images/svg/emptystate-kota.svg"  class="img-responsive">
              <div class="content-step-1" style="text-align:center">
                Oppss
              </div>
              <div class="fa-new-step1-content" style="text-align:center">
                Provinsi yang kamu cari tidak dapat ditemukan
              </div>
            </div>
            <button  class="buttom-modal button-continue" :disabled="chooseProvinceID == null" @click="closeModalProv()">
              PILIH
            </button>
          </div>
        </div>
      </div>
    </div>
    <button  class="button-fixed-1 button-continue mt-3" :disabled="chooseCityID == null"  @click="nextStep()">
      LANJUTKAN
    </button>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'Step1',
  data() {
    return {
      cities: [],
      provinces: [],
      chooseCityID: null,
      chooseCityName: 'Pilih kota',
      chooseProvinceID: null,
      chooseProvinceName: 'Pilih provinsi',
      kdProv: null,
      env: '',
    }
  },
  props: {
    cityId: {
      type: String,
      default: null,
    },
    cityName: {
      type: String,
      default: null,
    },
    provId: {
      type: String,
      default: null,
    },
    provName: {
      type: String,
      default: null,
    },
    mENV: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    this.env = this.mENV.env;
    this.chooseCityName = this.cityName;
    this.getResponseProv('');
    this.chooseCityID = this.cityId;
    this.chooseProvinceID = this.provId;
    this.chooseProvinceName = this.provName;
  },
  methods: {
    getResponseProv(keyName) {
      axios.get(`${this.env}/api/master/cities`, {
        params: {
          q: keyName,
          status_adm: 'PROV'
        },
      }).then(({ data }) => {
       this.provinces = data.data;
      });
    },
    getResponseCity(keyName) {
      if (this.chooseProvinceID) {
        axios.get(`${this.env}/api/master/cities`, {
          params: {
            q: keyName,
            filter_by: 'kd_prov',
            filter_value: this.kdProv,
            status_adm: 'KABU'
          },
        }).then(({ data }) => {
        this.cities = data.data;
        });
      }
    },
    chooseProvince(id, name, provId) {
      this.chooseProvinceID = id;
      this.chooseProvinceName = name;
      this.kdProv = provId;
    },
    chooseCity(id, name) {
      this.chooseCityID = id;
      this.chooseCityName = name;
    },
    closeModalProv() {
      $('#modalProv').modal('toggle');
    },
    closeModalCity() {
      $('#modalCity').modal('toggle');
    },
    searchProvince(event) {
      this.getResponseProv(event.target.value);
    },
    searchCity(event) {
      this.getResponseCity(event.target.value);
    },
    nextStep() {
      this.$emit('submit:cityID', this.chooseCityID);
      this.$emit('submit:cityName', this.chooseCityName);
      this.$emit('submit:provID', this.chooseProvinceID);
      this.$emit('submit:provName', this.chooseProvinceName);
    }
  }
};
</script>